const translations = {
    applicationNameFieldLabel: 'Name'
};

export default translations;
